import { render } from "./AppTableBodyCell.vue?vue&type=template&id=1af3e808&ts=true"
import script from "./AppTableBodyCell.vue?vue&type=script&lang=tsx"
export * from "./AppTableBodyCell.vue?vue&type=script&lang=tsx"

import "./AppTableBodyCell.vue?vue&type=style&index=0&id=1af3e808&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__